'use client';

import Styles from '../sleep-expert.module.scss';
import { IStoreInfo } from '~/interfaces/get-store-info';
import {
  formatPhoneNumber,
  isPurchaseChannelStore,
  isNationalSalesChat,
} from '~/utils/utils';
import {
  FALLBACK_STORE_PHONE,
  EVENT_WMAP_ORDER_SUMMARY_CALL_CLICK,
  EVENT_WMAP_ORDER_SUMMARY_CHAT_CLICK,
} from '~/constant/constants';
import ChatLink from '../../chat-link';
import PhoneLink from '../../phone-link';
import { usePaymentReview, useSelectedPaymentOption } from '~/store/wmap-store';
import { TYPES } from '~/modules/payment/constants';

export interface ISleepExpert {
  storeId: string | null;
  storeInfo?: IStoreInfo;
  enableMSChat?: boolean;
}

const SleepExpertContent: React.FC<ISleepExpert> = ({
  storeId,
  storeInfo,
  enableMSChat,
}) => {
  const selectedPaymentOption = useSelectedPaymentOption();
  const paymentReview = usePaymentReview();
  if (!storeId) return <></>;
  const storeName = storeInfo?.name || '';
  const storePhone = formatPhoneNumber(
    storeInfo?.phoneNumber || FALLBACK_STORE_PHONE,
  );
  const isChannelStore: boolean = isPurchaseChannelStore(
    storeInfo?.purchaseChannel,
  );
  const nationalSalesChat = isNationalSalesChat(storeId ?? '');
  const isProgressiveReview: boolean =
    (selectedPaymentOption === TYPES.PROGRESIVE && paymentReview.review) ||
    false;
  const isAffirm: boolean = selectedPaymentOption === TYPES.AFFIRM;

  return (
    <div
      className={`${Styles.sleepExpertWrapper} ${isProgressiveReview && Styles.sleepExpertReview} ${isAffirm && Styles.sleepExpertAffirm}`}
    >
      <h3 tabIndex={0}>
        Talk to a Sleep Expert
        <span className="trade-mark" />
      </h3>
      {isChannelStore && storeName && (
        <>
          <h4 tabIndex={0}>Your Store Is</h4>
          <p className={Styles.location} tabIndex={0}>
            <span className="location" />
            {storeName}
          </p>
        </>
      )}
      {!nationalSalesChat && storePhone && (
        <p className={Styles.phone}>
          <span className="phone" />
          <PhoneLink
            id="wmap-sleepexpert-call"
            phoneNumber={storePhone}
            label={`Call: ${storePhone}`}
            eventDescription={EVENT_WMAP_ORDER_SUMMARY_CALL_CLICK}
          />
        </p>
      )}

      {nationalSalesChat && (
        <p className={Styles.chat}>
          <span className="icon-chat" />
          <ChatLink
            label="Start a chat now"
            id="sleep-expert-chat"
            styleClass={Styles.chatText}
            eventDescription={EVENT_WMAP_ORDER_SUMMARY_CHAT_CLICK}
            enableMSChat={enableMSChat}
          />
          <span className="icon-arrow" />
        </p>
      )}
    </div>
  );
};

export default SleepExpertContent;
